module.exports = document
